import { ContactDialog } from 'src/components/dialogs'
import AddIcon from '@material-ui/icons/Add'
import { Tooltip, makeStyles, Button, Hidden, useIsMobile } from '@paintscout/ui'
import type { ButtonProps, StyleClasses, MuiTheme as Theme } from '@paintscout/ui'
import { useDialogs, useUser, useUserPermissions } from '@paintscout/ui-business'
import type { Contact } from '@paintscout/api'
import { goToContact } from 'src/util/routing'
import React from 'react'

const useStyles = makeStyles<Theme, ContactDialogButtonProps>(
  () => ({
    root: {},
    newButton: {}
  }),
  { name: 'ContactDialogButton' }
)

export interface ContactDialogButtonProps extends Omit<ButtonProps, 'classes'> {
  classes?: StyleClasses<typeof useStyles>
  label?: string
  onBack?: (event: React.MouseEvent<HTMLElement>) => void
  onCancel?: (event: React.MouseEvent<HTMLElement>) => void
  onConfirm?: (contact: Contact) => void
  noIcon?: boolean
  contactId?: string
  disableDelete?: boolean
  onCreateNew?: (query: string) => any
}

function ContactDialogButton(props: ContactDialogButtonProps) {
  const { openDialog, dismissDialog, dismissAllDialogs } = useDialogs()
  const classes = useStyles(props)
  const { label, onConfirm, noIcon, contactId, disableDelete, disabled, onCreateNew, onBack, onCancel } = props
  const { trialExpired, isSubscribed } = useUser()
  const { permissionToCreateContact } = useUserPermissions()
  const mobile = useIsMobile()

  return (
    <Tooltip title={trialExpired ? `Your trial has expired` : ''} placement="left">
      <div className={classes.newButton}>
        {/* div allows tooltip to work when button is disabled */}
        <Button
          {...props}
          icon={noIcon ? null : AddIcon}
          disabled={disabled || trialExpired || !permissionToCreateContact || !isSubscribed}
          onClick={() => {
            if (onCreateNew) {
              onCreateNew('')
            } else {
              openDialog(ContactDialog, {
                contactId,
                disableDelete,
                onConfirm: async (contact: Contact) => {
                  if (onConfirm) {
                    onConfirm(contact)
                    dismissDialog()
                    return
                  }
                  goToContact(contact._id)
                  dismissDialog()
                },
                onBack: onBack ?? dismissDialog,
                onCancel: onCancel ?? dismissAllDialogs
              })
            }
          }}
          size={props.size ? props.size : mobile ? 'large' : 'medium'}
        >
          {label ? (
            label
          ) : (
            <>
              {' '}
              New <Hidden mdDown={true}>Contact</Hidden>
            </>
          )}
        </Button>
      </div>
    </Tooltip>
  )
}

export default ContactDialogButton
